import classNames from 'classnames'

import {
  QA_CONTEXT_WIDGET,
  QA_NAME_PROFILE_ACTIONS_SECTION,
  QA_SECTION_KEY,
} from '../../../../constants/qa'
import { useStickyShadow } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'

import * as styles from './DesktopActionsWidget.module.css'

function DesktopActionsWidget({
  actionsWidget,
  isWidgetsHidden = false,
  widgets,
}) {
  const { isStuck, ref: stickyRef } = useStickyShadow()

  const sectionQaProps = getQaSelector(
    { context: QA_CONTEXT_WIDGET, value: QA_NAME_PROFILE_ACTIONS_SECTION },
    QA_SECTION_KEY
  )

  return (
    <>
      <div
        {...sectionQaProps}
        className={classNames(styles.stickyActions, {
          [styles.shadow]: isStuck,
        })}
        ref={stickyRef}
      >
        {actionsWidget}
      </div>
      <div
        className={classNames(styles.widgets, {
          [styles.hidden]: isWidgetsHidden,
        })}
      >
        {widgets}
      </div>
    </>
  )
}

export default DesktopActionsWidget
